import apiRoutes from "@/routes/apiRoutes";

export const getRestaurantDetailsWithBranches = async () => {
  const response = await fetch(apiRoutes.auth.restaurantDetails, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const result = await response.json();
  return result?.data;
};